import React from 'react';
import { ForgeConfigPageWrapper } from '@appsvio/config-page-wrapper/dist/esm/forgeConfigPageWrapper';
import { Footer, GetStartedPage } from '@appsvio/get-started-page';

import { DOCS_URL, CONTACT_URL } from '../../../common/constants';

import { handleArcadeClick } from './components/arcadeClickHandler';
import Description from './components/Description';
import { SECTIONS } from './components/Sections';

export const GetStartedEntryPoint = () => {
    return (
        <ForgeConfigPageWrapper
            title='Getting started'
            documentationLink={DOCS_URL}
            contactUsLink={CONTACT_URL}
            description={<Description />}
            footer={<Footer linkOpener={handleArcadeClick} />}
        >
            <GetStartedPage
                linkOpener={handleArcadeClick}
                sections={SECTIONS}
            />
        </ForgeConfigPageWrapper>
    );
};
